/**
 * ヘッダーの機能
 */
export default function headerFunc() {
  (function ($) {
    // 検索バーの有効/無効でヘッダーにclass付与
    $('.search-item').on('click', function () {
      // $('.search-item').toggleClass('js-active');
      if (!$(this).hasClass('active')) {
        $('#site-navigation').addClass('active-search');
      } else {
        $('#site-navigation').removeClass('active-search');
      }
    });
  })(jQuery);
}
